// Hide header on scroll down, show on scroll up
let lastScrollTop = 0;
const delta = 5;
let didScroll;

window.addEventListener('scroll', () => {
  didScroll = true;
});

setInterval(() => {
  if (didScroll) {
    hasScrolled();
    didScroll = false;
  }
}, 250);

function hasScrolled() {
  const filterBar = document.querySelector('.filter-bar--sticky');
  if (!filterBar) return;

  const st = window.pageYOffset;

  // Make sure they scroll more than delta
  if (Math.abs(lastScrollTop - st) <= delta) return;

  // If they scrolled down and are past the navbar
  if (st > lastScrollTop && st > filterBar.offsetHeight) {
    // Scroll Down
    filterBar.classList.add('filter-bar--hidden');
    document.documentElement.classList.remove('sticky-header-enabled');
  } else {
    // Scroll Up
    // If did not scroll past the document (possible on mac)
    if (st + window.innerHeight < document.documentElement.scrollHeight) {
      filterBar.classList.remove('filter-bar--hidden');
      document.documentElement.classList.add('sticky-header-enabled');
    }
  }

  lastScrollTop = st;
}
